import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    component: {
      marginTop: "1.8rem",
      marginBottom: "1.8rem",
      width: "100%",
      height: "324px",
      backgroundColor: "#FFFFFF",
      borderRadius: "2px",
      display: "flex",
      justifyContent: "space-between",
    },
    align: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      margin: "10px",
      marginTop: "20px",
      marginLeft: "20px",
    },
    parag: {
      color: "#808080",
      marginTop: "80px",
    },
    grafico: {
      margin: "20px",
      marginTop: "40px",
    },

  })
);

export default useStyles;